import { render, staticRenderFns } from "./DocsCard.vue?vue&type=template&id=94f72702&scoped=true&lang=pug&"
import script from "./DocsCard.vue?vue&type=script&lang=ts&"
export * from "./DocsCard.vue?vue&type=script&lang=ts&"
import style0 from "./DocsCard.vue?vue&type=style&index=0&id=94f72702&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f72702",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VHover,VIcon})
